<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/pc_banner_sup_wallet.webp')">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          ウォレットの紹介
        </h1>

        <h2 class="subheading fs_15px">
          勝winでは業界初の独立型ウォレットを採用しており、<br>
          お客様が効率的に資金を管理できるようにしております。
        </h2>

        <h1 class="main-title">
          ウォレットの種類一覧
        </h1>

        <p class="ff_Mincho fs_15px text_center">
          <a class="subheading fs_15px anchorTo" @click="scrollTo('anchor1')">現金ウォレット</a>
        </p>
        <p class="ff_Mincho fs_15px text_center">
          <a class="subheading fs_15px anchorTo" @click="scrollTo('anchor2')">ボーナスウォレット</a>
        </p>

        <p class="ff_Mincho fs_15px text_center">
          <a class="subheading fs_15px anchorTo" @click="scrollTo('anchor3')">ポイントウォレット</a>
        </p>
        <p class="ff_Mincho fs_15px text_center">
          <a class="subheading fs_15px anchorTo" @click="scrollTo('anchor4')">アフィリエイトウォレット</a>
        </p>

        <hr class="hr_line my_5r">

        <h1 id="anchor1" class="main-title">
          現金ウォレット
        </h1>

        <ol class="list-type-disc text-color-primary ff_Mincho fw_bold">
          <li>
            入金完了後、入金額が自動的に【現金ウォレット】に移動され、入金ボーナスは自動的に【ボーナスウォレット】に移動されます。
          </li>
          <li>
            お客様が入金された額が【現金ウォレット】に保管されます。
            ※ボーナスは含みません。
          </li>
          <li>「ベット額」が入金額の2倍に達した場合、すぐに出金申請が行えます。</li>
        </ol>

        <h1 class="main-title mt_5r">
          【現金ウォレット】出金条件：
        </h1>

        <div class="img-style-bor-sha">
          <img :src="$getThemeImagePath('sup/wallet_pc_01.png')" alt="">
        </div>
        <p class="subheading text_left fs_6">
          例：10,000円入金の場合、ゲームで20,000円ベットする必要があります。<br>
          元本累計の有効なベット額が、引き出し制限額と等しいもしくは大きい場合、出金申請が可能となります。
        </p>

        <h1 class="main-title mt_5r">
          【現金ウォレット】を開く
        </h1>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': toggleStates.anchor1}" @click="toggleState('anchor1')">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !toggleStates.anchor1}" @click="toggleState('anchor1')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents" :class="{'is-contents-active': toggleStates.anchor1}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面のアカウントをプルダウンし「アカウント」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_02.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウント画面の【現金ウォレット】欄を確認
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_03.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !toggleStates.anchor1}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_01.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウントをプルダウンし「アカウント」をクリック：<br>
                【現金ウォレット】を確認
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_02.png')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line my_5r">

        <h1 id="anchor2" class="main-title">
          【ボーナスウォレット**】**
        </h1>

        <ol class="list-type-disc ff_Mincho fw_bold">
          <li class="text-color-primary">
            キャンペーンボーナスは【ボーナスウォレット】に配付されます。
          </li>
          <li class="text-color-primary">
            【現金ウォレット】残高が0円になった場合、システムは【ボーナスウォレット】の残高からゲームをプレイできます。
          </li>
          <li class="text-color-primary">
            【ボーナスウォレット】ベット額の合計がボーナス総額の20倍に達した場合、システムは自動で【ボーナスウォレット】の残高すべてを【現金ウォレット】に移動し、出金申請が可能となります
          </li>
          <li class="text-color-primary">
            【ボーナスウォレット】ゲームのベットにVIPアップグレードの計算は含まれません。
          </li>
          <li class="text-color-primary">
            【ボーナスウォレット】ゲームのベットにKatsuポイントの計算は含まれません
          </li>
        </ol>

        <h1 class="main-title mt_5r">
          【ボーナスウォレット】から<br>
          【現金ウォレット】への移動条件：
        </h1>

        <div class="img-style-bor-sha">
          <img :src="$getThemeImagePath('sup/wallet_pc_04.png')" alt="">
        </div>

        <p class="text-color-primary fs_6 ff_Mincho fw_bold">
          ボーナスの有効ベットが額が「送金限度額」と等しい場合、【ボーナスウォレット】残高が【現金ウォレット】残高に移動されます。
        </p>
        <p class="text-color-primary fs_6 ff_Mincho fw_bold">
          例：出金賭け条件20倍(獲得ボーナス10,000円×20＝200,000円)をプレイしたあと、改めて残高をご確認ください。その時点で所持する勝利金合計が【ボーナスウォレット】の残高から【現金ウォレット】残高へ移動し、出金申請が可能となります。
        </p>

        <h1 class="main-title mt_5r mb_3">
          【ボーナスウォレット】を開く
        </h1>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-1" :class="{'is-btn-active': toggleStates.anchor2}" @click="toggleState('anchor2')">
              PC版
            </li>
            <li class="tab-list-item-group-1" :class="{'is-btn-active': !toggleStates.anchor2}" @click="toggleState('anchor2')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-1" :class="{'is-contents-active': toggleStates.anchor2}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面のアカウントをプルダウンし「アカウント」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_02.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウント画面の【ボーナスウォレット】欄を確認
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_05.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-1" :class="{'is-contents-active': !toggleStates.anchor2}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_01.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウントをプルダウンし「アカウント」をクリック：<br>

                【ボーナスウォレット】を確認
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_03.png')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <h1 class="main-title mt_5r mb_5">
          【ボーナスウォレット】の使用における、
          ベットのルールおよびゲームの反映率の説明です。 以下の数点にご留意ください。
        </h1>

        <p class="text-color-primary text_center subheading fs_6">
          プレイするゲームの種類により、同じベット額であっても【ボーナスウォレット】のベット条件の反映率が異なります。
        </p>
        <ol class="list-type-disc fs_14px fw_bold text_center list-inside text-color-primary ff_Mincho">
          <li>ライブ系ゲーム、計算率20%</li>
          <li>スロット系ゲーム、計算率100%</li>
          <li>テーブル系ゲーム、計算率20％</li>
          <li>スキル系ゲーム、計算率20％</li>
        </ol>

        <p class="text-color-primary text_center subheading fs_6 my_5r">
          ボーナスをより広く公平にご利用いただくために、<br>
          以下の事項にご留意いただき、違反した場合はボーナスの出金ができなくなりますので、
          ご注意ください。
        </p>

        <ol class="list-type-disc fs_14px text-color-primary ff_Mincho fw_bold">
          <li>
            GekiPachi・競馬: 全種類のパチスロゲームと競馬は、ボーナスを利用してプレイすることができません。
          </li>
          <li>
            【ボーナスウォレット】での【スロット系ゲーム/ビデオビンゴ】の1回のベット額は625円以内、【テーブル系ゲーム/ライブビデオ】の場合は3,000円以内とし、これを超えると違反とみなし、ボーナスは没収されます。
          </li>
          <li>
            【ボーナスウォレット】を使用してボーナスまたはフリースピンを購入してベットをすると、最大ベット額を超えてしまい、それらは違反とみなされ、関連する報酬はすべて没収されます。
          </li>
          <li>
            【ボーナスウォレット】を使用してベットする際、リスクを軽減または排除するために、複数の結果をカバーするための行為。
          </li>
          <li>複数のアカウントもしくは代理アカウントを使用して登録した場合。</li>
          <li>
            スロット系ゲーム の仕組みをアップグレードするために、ボーナス資金を繰り返し
            (悪用または詐欺目的) 使用すること。
          </li>
        </ol>

        <hr class="hr_line my_5r">

        <h1 id="anchor3" class="main-title mt_5r mb_5">
          ポイントウォレット
        </h1>

        <ol class="list-type-disc text-color-primary ff_Mincho fw_bold">
          <li>
            【現金ウォレット】を使用してベットした場合、Katsuポイントを獲得できます。
          </li>
          <li>【Katsuポイントはモール内のギフトパックと交換できます</li>
          <li>【ボーナスウォレット】からのベットはKatsuポイントの計算に含まれません。</li>
          <li>Katsuポイントの使用方法について</li>
        </ol>

        <h1 class="main-title mt_5r mb_5">
          【ポイントウォレット】を開く
        </h1>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-2" :class="{'is-btn-active': toggleStates.anchor3}" @click="toggleState('anchor3')">
              PC版
            </li>
            <li class="tab-list-item-group-2" :class="{'is-btn-active': !toggleStates.anchor3}" @click="toggleState('anchor3')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-2" :class="{'is-contents-active': toggleStates.anchor3}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面のアカウントをプルダウンし「アカウント」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_06.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウント画面の【ボーナスウォレット】欄を確認
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_07.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-2" :class="{'is-contents-active': !toggleStates.anchor3}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_01.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウントをプルダウンし「アカウント」をクリック：<br>
                【ポイントウォレット】を確認
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_mb_02.png')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->

        <hr class="hr_line my_5r">

        <h1 id="anchor4" class="main-title mt_5r mb_5">
          アフィリエイトウォレット
        </h1>

        <ul class="list-type-disc text-color-primary ff_Mincho fw_bold">
          <li>
            「フレンド紹介特典Kastsuリベート」キャンペーンで発生したリベートは、すべて【アフィリエイトウォレット】に配付されます。
          </li>
          <li>【アフィリエイトウォレット】はベット不要で、出金申請が可能です。</li>
          <li>
            【アフィリエイトウォレット】の残高は【現金ウォレット】に移動し、ゲームをプレイできます。
          </li>
        </ul>

        <h1 class="main-title mt_5r mb_5">
          【アフィリエイトウォレット】を開く
        </h1>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-group-3" :class="{'is-btn-active': toggleStates.anchor4}" @click="toggleState('anchor4')">
              PC版
            </li>
            <li class="tab-list-item-group-3" :class="{'is-btn-active': !toggleStates.anchor4}" @click="toggleState('anchor4')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-group-3" :class="{'is-contents-active': toggleStates.anchor4}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面のアカウントをプルダウンし「アカウント」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_02.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6 text_left mb_1">
                アカウント画面の【アフィリエイトウォレット】欄を確認：
              </h2>
              <ol class="list-type-decimal text-color-primary fs_6 ff_Mincho fw_bold">
                <li>振替：Katsuリベートの残高を【現金ウォレット】へ移動</li>
                <li>出金：【アフィリエイトウォレット】から出金</li>
              </ol>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/wallet_pc_08.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-group-3" :class="{'is-contents-active': !toggleStates.anchor4}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_01.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウントをプルダウンし「アカウント」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_05.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <h2 class="subheading fs_6 text_left">
                アカウント画面に移動し、Katsuリベート欄を確認
              </h2>
              <ol class="list-type-decimal text-color-primary fs_6 ff_Mincho fw_bold">
                <li>振替：Katsuリベートの残高を【現金ウォレット】へ移動</li>
                <li>出金：【アフィリエイトウォレット】から出金</li>
              </ol>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/wallet_mb_06.png')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      toggleStates: {
        anchor1: true,
        anchor2: true,
        anchor3: true,
        anchor4: true
      }
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleState(key) {
      if (this.toggleStates.hasOwnProperty(key)) {
        this.toggleStates[key] = !this.toggleStates[key]
      }
    },
    scrollTo(id) {
      setTimeout(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 10)
    }
  }
}
</script>
